import { ExternalLink } from "lucide-react";
import { Badge } from "./ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { getSystemDisplayName, getSystemIconPath } from "../lib/systemOfRecord";

interface SystemOfRecordBadgeProps {
  externalRef: { externalRef: string };
  controlUrl?: string | null;
  iconOnly?: boolean;
  // Explicit source override. Controls' ref is a compound `source::...` key
  // that the badge parses to find the source; work steps' ref is a plain
  // `WS#<id>` display string with no embedded source, so callers pass this
  // instead of relying on the split("::")[0] parse.
  source?: string;
}

export const SystemOfRecordBadge = ({
  externalRef,
  controlUrl,
  iconOnly = false,
  source: explicitSource,
}: SystemOfRecordBadgeProps) => {
  const source = explicitSource ?? externalRef.externalRef.split("::")[0] ?? "";
  const displayName = getSystemDisplayName(source);
  const iconPath = getSystemIconPath(source);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="inline-flex"
          onClick={
            controlUrl
              ? (e) => {
                  e.stopPropagation();
                  window.open(controlUrl, "_blank", "noopener,noreferrer");
                }
              : undefined
          }
        >
          <Badge
            variant="outline"
            className={`gap-1.5 whitespace-nowrap ${controlUrl ? "cursor-pointer" : ""}`}
          >
            <img
              src={iconPath}
              alt={displayName}
              className="h-3.5 w-3.5 shrink-0"
            />
            {!iconOnly && (
              <>
                {displayName}
                {controlUrl && <ExternalLink className="h-3 w-3" />}
              </>
            )}
          </Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        {controlUrl ? `Open in ${displayName}` : `Linked to ${displayName}`}{" "}
        (ref: {externalRef.externalRef})
      </TooltipContent>
    </Tooltip>
  );
};
